import { AnalyticCostByYear } from '@app/api/models/Maintenances';
import styled from '@emotion/styled';
import dayjs from 'dayjs';
import React from 'react';
import useGetProjectArea from '../../../lib/hooks/useGetProjectArea';
import useGetProjectInfo from '../../../lib/hooks/useGetProjectInfo';
import useGetAnaltyicList from '../hooks/useGetAnalyticList';
import PieGraph from './PieGraph';

const PieGraphCostm2 = () => {
    const { data: analtyicList } = useGetAnaltyicList();
    const projectInfo = useGetProjectInfo();
    const { data: area } = useGetProjectArea();

    const m2 = area?.sum;
    if (!m2) {
        return <PieGraph headerPrice={'Kostnad per m²'} headerPie={'Kostnad per kategori'} price={'Boarea saknas'} />;
    }
    if (!projectInfo) return null;
    if (!analtyicList) return null;
    if (!analtyicList.length) {
        return (
            <PieGraph
                headerPrice={'Kostnad per m²'}
                headerPie={'Kostnad per kategori'}
                price={'Inga planerade underhåll'}
            />
        );
    }

    const uniqueYears = [...new Set(analtyicList.map(item => item.year)).values()];
    const maxYear = Math.max(...uniqueYears);
    const yearSpan = maxYear - +dayjs().format('YYYY');

    const uniqueCategories = [...new Set(analtyicList.map(item => item.maintenance_category.name)).values()];
    const avrageCostPerm2 =
        analtyicList
            .map(analyticCost =>
                analyticCost.completed_amount && +analyticCost.completed_amount
                    ? +analyticCost.completed_amount
                    : +analyticCost.planned_amount
            )
            .reduce((sum, current) => sum + current) /
        yearSpan /
        m2;

    const Category = class {
        constructor(categories: AnalyticCostByYear[], years: number[]) {
            this.costs = categories.map(catagory => {
                return catagory.completed_amount && +catagory.completed_amount
                    ? +catagory.completed_amount
                    : +catagory.planned_amount;
            });
            this.name = categories[0].maintenance_category.name;
            this.color = categories[0].maintenance_category.color;
            this.years = years;
        }
        costs: number[];
        name: string;
        color: string;
        years: number[];

        avrageCostm2() {
            return Math.round(this.costs.reduce((sum, current) => sum + current) / yearSpan / avrageCostPerm2);
        }
    };

    const categories = uniqueCategories.map(categoryName => {
        const CategoryClass = new Category(
            analtyicList.filter(item => item.maintenance_category.name === categoryName),
            uniqueYears
        );
        return CategoryClass;
    });

    const data = {
        labels: categories.map(category => category.name),
        datasets: [
            {
                label: 'kostnad per år',
                data: categories.map(category => category.avrageCostm2()),
                backgroundColor: categories.map(category => category.color)
            }
        ]
    };

    return (
        <PieGraph
            data={data}
            headerPrice={'Kostnad per m²'}
            headerPie={'Kostnad per kategori'}
            price={`${new Intl.NumberFormat('sv-SE', {
                style: 'currency',
                currency: 'SEK',
                maximumFractionDigits: 0
            }).format(avrageCostPerm2)}/m²`}
        />
    );
};

export default PieGraphCostm2;
